.container {
  padding: var(--mobile-gutter);
}

.office {
  padding: 20px 8px;
  border-bottom: 1px solid var(--black);
}

.officeName {
  margin-left: 8px;
  font-weight: var(--semibold-weight);
  margin-bottom: 16px;
}
